// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  WORKER_CONFIG_SET_GENERIC_WORKER_COST_DEFINITION,
} from './constants';

export function setGenericWorkerCostDefinition(cost_def) {
  return {
    type: WORKER_CONFIG_SET_GENERIC_WORKER_COST_DEFINITION,
    data: cost_def
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_SET_GENERIC_WORKER_COST_DEFINITION:
      return {
        ...state,
        genericWorkerCostDefinitions: action.data,
        numChanges: state.numChanges ? state.numChanges + 1 : 1,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/setGenericWorkerCostDefinition.js